import { render, staticRenderFns } from "./B2BPrinter.vue?vue&type=template&id=3384576c&scoped=true"
import script from "./B2BPrinter.vue?vue&type=script&lang=js"
export * from "./B2BPrinter.vue?vue&type=script&lang=js"
import style0 from "./B2BPrinter.vue?vue&type=style&index=0&id=3384576c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384576c",
  null
  
)

export default component.exports